import React from 'react';
import BrandGridProps from './props';
import style from './style.module.scss';

function BrandGrid({
  brands,
  heading = "Featured Brands Offering New Boats",
  shopAllText = "Shop All Brands",
  shopAllHref = "/boats/condition-new/"
}: BrandGridProps) {
  return (
    <section id="featured-brands-section" data-test-sp="featured-brands" className={style.featuredBrandsSection}>
      <h2 className={style.heading} data-e2e="featured-brand-heading">{heading}</h2>
      
      <div className={style.grid} data-e2e="featured-brands-grid">
        {brands.map((brand) => (
          <div className={style.item} key={brand.name} data-e2e="featured-brand">
            <a href={brand.link} className={style.link}>
              <div className={style.imageWrapper}>
                <img
                  src={brand.logoUrl}
                  alt={brand.alt}
                  className={style.image}
                />
              </div>
            </a>
          </div>
        ))}
      </div>

      <a
        className="shop-brands"
        data-e2e="shop-all-brands"
        href={shopAllHref}
      >
        {shopAllText}
      </a>
    </section>
  );
}

export default React.memo(BrandGrid); 